import React from 'react';
import PropTypes from 'prop-types';
import WeeklyTimeSelector from './WeeklyTimeSelector';
import SpecialDaySelector from './SpecialDaySelector';

class AppointmentRestrictions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: 'weeklyTime',
      lockboxHoursModalVisible: false,
    };
  }

  /* 
    When 'Auto-Confirm All Showings' is enabled, change the Showing Availabilities
    table to display 'Auto-Conf' instead of 'Available'
  */
  mapAutoConfAvailabilities(availabilities) {
    const autoConfAvailabilities = {};
    Object.keys(availabilities).forEach(time => {
      if (
        availabilities[time] === 'Available' ||
        availabilities[time] === true
      ) {
        autoConfAvailabilities[time] = 'AutoConfirm';
      } else {
        autoConfAvailabilities[time] = availabilities[time];
      }
    });
    return autoConfAvailabilities;
  }

  handleOpenLockboxHoursModal = () => {
    this.setState({ lockboxHoursModalVisible: true });
  };

  handleCloseLockboxHoursModal = () => {
    this.setState({ lockboxHoursModalVisible: false });
  };

  render() {
    const { activeTab, lockboxHoursModalVisible } = this.state;
    return (
      <section className="appointment-restrictions">
        <legend>Showing Availability / Restrictions</legend>

        <nav className="appointment-restrictions__tabs btn-group">
          <button
            className={`btn btn-info btn-md ${
              activeTab === 'weeklyTime' ? 'active' : ''
            }`}
            onClick={() => {
              this.setState({ activeTab: 'weeklyTime' });
            }}
            data-cy="pick-weekly-availability"
          >
            <i className="fa fa-calendar" />
            &nbsp; Weekly
          </button>

          <button
            className={`btn btn-info btn-md ${
              activeTab === 'specialDays' ? 'active' : ''
            }`}
            onClick={() => {
              this.setState({ activeTab: 'specialDays' });
            }}
            data-cy="pick-special-days"
          >
            <i className="fa fa-exclamation" />
            &nbsp; Special days
          </button>

          <span className="appointment-restrictions__instructions">
            Click and drag your cursor to select multiple time slots
          </span>
        </nav>

        {this.state.activeTab === 'weeklyTime' && (
          <WeeklyTimeSelector
            timeSelection={this.props.timeSelection}
            selectTimes={this.props.selectTimes}
            disableAutoConfirm={
              this.props.disableAutoConfirm || this.props.autoConfirm
            }
            noMoreShowings={this.props.noMoreShowings}
            autoConfirm={this.props.autoConfirm}
            mapAutoConfAvailabilities={this.mapAutoConfAvailabilities}
            lockboxHoursModalVisible={lockboxHoursModalVisible}
            openLockboxHoursModal={this.handleOpenLockboxHoursModal}
            closeLockboxHoursModal={this.handleCloseLockboxHoursModal}
            access={this.props.access}
            supraLockbox={this.props.supraLockbox}
            supraLockboxAccessHours={this.props.supraLockboxAccessHours}
            supraLockboxRestrictedHoursMap={
              this.props.supraLockboxRestrictedHoursMap
            }
            updateLockboxHours={this.props.updateLockboxHours}
            listingTimezone={this.props.listingTimezone}
          />
        )}

        {this.state.activeTab === 'specialDays' && (
          <SpecialDaySelector
            specialDays={this.props.specialDays}
            unavailableDays={this.props.unavailableDays}
            updateSpecialDays={this.props.updateSpecialDays}
            disableAutoConfirm={
              this.props.disableAutoConfirm || this.props.autoConfirm
            }
            noMoreShowings={this.props.noMoreShowings}
            autoConfirm={this.props.autoConfirm}
            mapAutoConfAvailabilities={this.mapAutoConfAvailabilities}
          />
        )}
      </section>
    );
  }
}

AppointmentRestrictions.propTypes = {
  selectTimes: PropTypes.func.isRequired,

  specialDays: PropTypes.objectOf(
    PropTypes.objectOf(
      PropTypes.oneOfType([
        PropTypes.string,
        // 'Available',
        // 'Restricted',
        // 'AutoConfirm',
        PropTypes.bool,
      ]),
    ),
  ).isRequired,

  unavailableDays: PropTypes.arrayOf(PropTypes.string).isRequired,

  updateSpecialDays: PropTypes.func.isRequired,
};

export default AppointmentRestrictions;
